jQuery(($) => {

    if ($('.o-providers-search-feed')[0]) {
        var form        = $('o-providers-search-feed__form'),
            searchInput = form.find('.m-providers-search-menu__input'),
            selectInput = form.find('.m-providers-search-menu__select');
    }
});